<div class="selector-juzgado-container">

  <!-- Campos de selección en línea -->
  <div class="campos-linea">

    <!-- Provincia -->
    <mat-form-field
      appearance="outline"
      class="campo"
      [class.campo-error]="provinciaInvalida"
      matAutocompleteOrigin #origin1="matAutocompleteOrigin">
      <mat-label>Provincia *</mat-label>
      <input
        matInput
        [formControl]="provinciaControl"
        [matAutocomplete]="autoProvincia"
        placeholder="Seleccionar provincia..."
        autocomplete="off"
        required>

      <mat-icon matSuffix *ngIf="loadingProvincias">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-icon>

      <mat-icon matSuffix *ngIf="!loadingProvincias && provinciaForm.get('provincia')?.value" color="primary">
        check_circle
      </mat-icon>

      <mat-autocomplete
        #autoProvincia="matAutocomplete"
        [displayWith]="displayProvincia"
        (optionSelected)="onProvinciaSeleccionada($event.option.value)">
        <mat-option
          *ngFor="let provincia of provinciasFiltradas$ | async"
          [value]="provincia">
          <mat-icon>place</mat-icon>
          {{ provincia.nombre }}
        </mat-option>
      </mat-autocomplete>

      <mat-error *ngIf="provinciaInvalida">
        <mat-icon>error</mat-icon>
        Provincia es requerida
      </mat-error>
    </mat-form-field>

    <!-- Jurisdicción -->
    <mat-form-field
      appearance="outline"
      class="campo"
      [class.campo-error]="jurisdiccionInvalida"
      [class.campo-deshabilitado]="jurisdiccionForm.get('jurisdiccion')?.disabled">
      <mat-label>Jurisdicción *</mat-label>
      <input
        matInput
        [formControl]="jurisdiccionControl"
        [matAutocomplete]="autoJurisdiccion"
        placeholder="Seleccionar jurisdicción..."
        autocomplete="off"
        required>

      <mat-icon matSuffix *ngIf="loadingJurisdicciones">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-icon>

      <mat-icon matSuffix *ngIf="!loadingJurisdicciones && jurisdiccionForm.get('jurisdiccion')?.value" color="primary">
        check_circle
      </mat-icon>

      <mat-autocomplete
        #autoJurisdiccion="matAutocomplete"
        [displayWith]="displayJurisdiccion"
        (optionSelected)="onJurisdiccionSeleccionada($event.option.value)">
        <mat-option
          *ngFor="let jurisdiccion of jurisdiccionesFiltradas$ | async"
          [value]="jurisdiccion">
          <mat-icon>location_city</mat-icon>
          {{ jurisdiccion.descripcion }}
        </mat-option>
      </mat-autocomplete>

      <mat-error *ngIf="jurisdiccionInvalida">
        <mat-icon>error</mat-icon>
        Jurisdicción es requerida
      </mat-error>
    </mat-form-field>

    <!-- Fuero -->
    <mat-form-field
      appearance="outline"
      class="campo"
      [class.campo-error]="fueroInvalido"
      [class.campo-deshabilitado]="fueroForm.get('fuero')?.disabled">
      <mat-label>Fuero *</mat-label>
      <input
        matInput
        [formControl]="fueroControl"
        [matAutocomplete]="autoFuero"
        placeholder="Seleccionar fuero..."
        autocomplete="off"
        required>

      <mat-icon matSuffix *ngIf="loadingFueros">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-icon>

      <mat-icon matSuffix *ngIf="!loadingFueros && fueroForm.get('fuero')?.value" color="primary">
        check_circle
      </mat-icon>

      <mat-autocomplete
        #autoFuero="matAutocomplete"
        [displayWith]="displayFuero"
        (optionSelected)="onFueroSeleccionado($event.option.value)">
        <mat-option
          *ngFor="let fuero of fuerosFiltrados$ | async"
          [value]="fuero">
          <mat-icon>gavel</mat-icon>
          {{ fuero.descripcion }}
        </mat-option>
      </mat-autocomplete>

      <mat-error *ngIf="fueroInvalido">
        <mat-icon>error</mat-icon>
        Fuero es requerido
      </mat-error>
    </mat-form-field>

    <!-- Juzgado -->
    <mat-form-field
      appearance="outline"
      class="campo"
      [class.campo-error]="juzgadoInvalido"
      [class.campo-deshabilitado]="juzgadoForm.get('juzgado')?.disabled">
      <mat-label>Juzgado *</mat-label>
      <input
        matInput
        [formControl]="juzgadoControl"
        [matAutocomplete]="autoJuzgado"
        placeholder="Seleccionar juzgado..."
        autocomplete="off"
        required>

      <mat-icon matSuffix *ngIf="loadingJuzgados">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-icon>

      <mat-icon matSuffix *ngIf="!loadingJuzgados && juzgadoForm.get('juzgado')?.value" color="primary">
        check_circle
      </mat-icon>

      <mat-autocomplete
        #autoJuzgado="matAutocomplete"
        [displayWith]="displayJuzgado"
        (optionSelected)="onJuzgadoSeleccionado($event.option.value)">
        <mat-option
          *ngFor="let juzgado of juzgadosFiltrados$ | async"
          [value]="juzgado">
          <mat-icon>account_balance</mat-icon>
          {{ juzgado.descripcion }}
          <span class="juzgado-detalle" *ngIf="juzgado.localidad">
            - {{ juzgado.localidad }}
          </span>
        </mat-option>
      </mat-autocomplete>

      <mat-error *ngIf="juzgadoInvalido">
        <mat-icon>error</mat-icon>
        Juzgado es requerido
      </mat-error>
    </mat-form-field>

    <!-- Botón limpiar -->
    <button
      mat-icon-button
      color="warn"
      (click)="limpiarSelecciones()"
      [disabled]="!provinciaForm.get('provincia')?.value && !jurisdiccionForm.get('jurisdiccion')?.value && !fueroForm.get('fuero')?.value && !juzgadoForm.get('juzgado')?.value"
      class="boton-limpiar"
      matTooltip="Limpiar selecciones">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <!-- Mensaje de validación general -->
  <div class="mensaje-validacion" *ngIf="!esFormularioValido() && (provinciaForm.touched || jurisdiccionForm.touched || fueroForm.touched || juzgadoForm.touched)">
    <mat-icon color="warn">warning</mat-icon>
    <span>Complete todos los campos requeridos para continuar</span>
  </div>

  <!-- Selección actual -->
  <div class="seleccion-actual" *ngIf="provinciaForm.get('provincia')?.value || jurisdiccionForm.get('jurisdiccion')?.value || fueroForm.get('fuero')?.value || juzgadoForm.get('juzgado')?.value">
    <div class="titulo-seleccion">
      <mat-icon [color]="esFormularioValido() ? 'primary' : 'warn'">
        {{ esFormularioValido() ? 'check_circle' : 'info' }}
      </mat-icon>
      <span>Selección Actual</span>
      <div class="estado-validacion" *ngIf="esFormularioValido()">
        <mat-icon color="primary">verified</mat-icon>
        <span>Completo</span>
      </div>
    </div>

    <div class="chips-seleccion">
      <mat-chip-set>
        <mat-chip
          *ngIf="provinciaForm.get('provincia')?.value"
          [removable]="false"
          class="chip-provincia">
          <mat-icon>place</mat-icon>
          {{ provinciaForm.get('provincia')?.value.nombre }}
        </mat-chip>

        <mat-chip
          *ngIf="jurisdiccionForm.get('jurisdiccion')?.value"
          [removable]="false"
          class="chip-jurisdiccion">
          <mat-icon>location_city</mat-icon>
          {{ jurisdiccionForm.get('jurisdiccion')?.value.descripcion }}
        </mat-chip>

        <mat-chip
          *ngIf="fueroForm.get('fuero')?.value"
          [removable]="false"
          class="chip-fuero">
          <mat-icon>gavel</mat-icon>
          {{ fueroForm.get('fuero')?.value.descripcion }}
        </mat-chip>

        <mat-chip
          *ngIf="juzgadoForm.get('juzgado')?.value"
          [removable]="false"
          class="chip-juzgado">
          <mat-icon>account_balance</mat-icon>
          {{ juzgadoForm.get('juzgado')?.value.descripcion }}
        </mat-chip>
      </mat-chip-set>
    </div>
  </div>

</div>
